import { useI18n } from '../lib/i18n';
import { Field, Input, Select } from './ui';

interface RealmFieldDefinition {
  key: string;
  label: string;
  required: boolean;
  schema: Record<string, unknown>;
}

interface Props {
  field: RealmFieldDefinition;
  value: unknown;
  disabled?: boolean;
  onChange: (value: unknown) => void;
}

export function RealmFieldInput({ field, value, disabled = false, onChange }: Props) {
  const { t } = useI18n();
  const enumValues = Array.isArray(field.schema.enum) ? field.schema.enum : undefined;
  if (enumValues) {
    const selected = value === null || value === undefined || value === '' ? '__empty__' : JSON.stringify(value);
    return <Field label={field.label} required={field.required}><Select name={field.key} value={selected} disabled={disabled} required={field.required} onChange={(event) => onChange(event.target.value === '__empty__' ? null : parseJson(event.target.value))}><option value="__empty__">{t('noValue')}</option>{enumValues.map((option) => <option key={JSON.stringify(option)} value={JSON.stringify(option)}>{String(option)}</option>)}</Select></Field>;
  }
  if (field.schema.type === 'boolean') {
    return <Field label={field.label} required={field.required}><Select name={field.key} value={value === true ? 'true' : value === false ? 'false' : ''} disabled={disabled} required={field.required} onChange={(event) => onChange(event.target.value === '' ? null : event.target.value === 'true')}><option value="">{t('noValue')}</option><option value="true">{t('yes')}</option><option value="false">{t('no')}</option></Select></Field>;
  }
  if (field.schema.type === 'number' || field.schema.type === 'integer') {
    return <Field label={field.label} required={field.required}><Input name={field.key} type="number" step={field.schema.type === 'integer' ? 1 : 'any'} min={numberSchemaValue(field.schema.minimum)} max={numberSchemaValue(field.schema.maximum)} value={typeof value === 'number' ? value : ''} disabled={disabled} required={field.required} onChange={(event) => onChange(event.target.value === '' ? null : Number(event.target.value))}/></Field>;
  }
  if (field.schema.type === 'array') {
    return <Field label={field.label} hint={t('commaSeparated')} required={field.required}><Input name={field.key} value={Array.isArray(value) ? value.map(String).join(', ') : ''} disabled={disabled} required={field.required} onChange={(event) => onChange(event.target.value.trim() ? event.target.value.split(',').map((item) => item.trim()).filter(Boolean) : null)}/></Field>;
  }
  const type = field.schema.format === 'date' ? 'date' : field.schema.format === 'email' ? 'email' : 'text';
  return <Field label={field.label} required={field.required}><Input name={field.key} type={type} minLength={numberSchemaValue(field.schema.minLength)} maxLength={numberSchemaValue(field.schema.maxLength)} pattern={typeof field.schema.pattern === 'string' ? field.schema.pattern : undefined} value={typeof value === 'string' ? value : ''} disabled={disabled} required={field.required} onChange={(event) => onChange(event.target.value || null)}/></Field>;
}

function numberSchemaValue(value: unknown): number | undefined {
  return typeof value === 'number' ? value : undefined;
}

function parseJson(value: string): unknown {
  try { return JSON.parse(value) as unknown; } catch { return value; }
}
